<template>
<keep-alive>
  <odd-page :title="title" :subtitle="subtitle">
    <template v-slot:header>
      <div class="d-flex align-items-center justify-content-end">
        <d-button
          v-if="showExportButton"
          theme="secondary"
          @click="handleExportButtonClick"
          class="mx-1"
        >
          <i class="material-icons">save_alt</i> EXPORT
        </d-button>
                <d-button
          v-if="showUpdateButton"
          theme="secondary"
          @click="handleUpdateButtonClick"
          class="mx-1"
        >
          <i class="material-icons">upgrade</i> UPDATE
        </d-button>
        <d-button
          v-if="showAddButton"
          theme="secondary"
          @click="handleAddButtonClick"
        >
          <i class="material-icons">add</i> ADD
        </d-button>

      </div>
    </template>
    <div class="d-flex align-items-end justify-content-between pb-2">
      <div class="d-inline">
        Search
        <d-input
          type="text"
          class="d-inline"
          size="sm"
          :placeholder="searchPlaceholder"
          v-model="search"
          :debounce="true"
          :debounceTimeout="500"
        />
      </div>
    </div>
    <div>
        <d-card>
          <d-card-header>
            <div class="d-flex align-items-end h-100 justify-content-start">
              <slot name="filters"></slot>
              <DropDownCheckList
                :items="selectabledColumns"
                text="Columns"
                icon="view_column"
                v-model="visibleColumns"
              />
              <odd-spinner
                v-if="loading"
                :size="20"
                :borderSize="3"
                class="ml-auto"
                style="margin-bottom: 5px;"
              />
              <d-button v-else theme="clear" class="ml-auto p-0" @click="handleRefresh">
                <i class="material-icons">refresh</i>
              </d-button>
            </div>
          </d-card-header>
          <OddTable
            :viewsetPath="viewset"
            :fields="__fields"
            :actions="actions"
            :filters="filters"
            :search="search"
            :refresh="refresh + gridPageRefresh"
            :ready="ready"
            paginationCssClass="card-footer"
            @loading="loading => (this.loading = loading)"
            @rowAction="handleRowAction"
            @query="handleQuery"
          />
        </d-card>
    </div>
    <slot name="modals"></slot>
  </odd-page>
  </keep-alive>
</template>

<script>
import Page from "@/components/layout/Page/Page.vue";
import DropDownCheckList from "@/components/DropDownChecklist.vue";
import OddTable from "@/components/DataGrid/OddTable.vue";
import DatetimeFormatters from "@/components/DataGrid/formatters/datetime.js";
import { usd } from "@/utils/currency.js";
import { PROTECTED_COLUMN_NAMES } from "@/components/DataGrid/Constants.js";
import PaymentStatusFormatters from "@/components/DataGrid/formatters/paymentStatus.js";
import CustomerFormatters from "@/components/DataGrid/formatters/customer.js";
import OrderStatusFormatters from "@/components/DataGrid/formatters/orderStatus.js";

export default {
  name: "odd-grid-page",
  components: {
    "odd-page": Page,
    DropDownCheckList,
    OddTable,
  },
  data() {
    return {
      showEditModal: false,
      loading: false,
      search: "",
      tableFilterValues: {},
      gridPageRefresh: 0,
      paymentStatusFilter: "",
      orderStatusFilter: "",
      visibleColumns: [],
      paymentStatusOptions: [
        { name: "", title: "All" },
        { name: "v", title: "Void" },
        { name: "p", title: "Paid" },
        { name: "u", title: "Unpaid" }
      ]
    };
  },
  props: {
    viewset: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    searchPlaceholder: {
      type: String,
      default: "search..."
    },
    showAddButton: {
      default: false
    },
    showExportButton: {
      default: false
    },
    showUpdateButton: {
      default: false
    },
    refresh: {
      type: Number,
      default: 0
    },
    ready: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    __fields() {
      return [
        {
          name: "_select-slot",
          title: "Select",
          visible: false,
          optional: false
        },
        ...this.fields,
        {
          name: "_actions-slot",
          title: "Actions",
          optional: false,
          clickable: false
        }
      ];
    },
    selectabledColumns() {
      return this.fields.filter(field => field["optional"] !== false);
    },
    schema() {
      return {
        fields: this.fields
          .filter(field => !!field.schema)
          .map(field => field.schema)
      };
    },
    orderStatusOptions() {
      const orderStatusOptionsList = [{ name: "", title: "All" }];
      this.$store.state.orderStatusOptions.list.forEach(option => {
        orderStatusOptionsList.push({
          name: option.value,
          title: option.internal_label
        });
      });
      return orderStatusOptionsList;
    }
  },
  watch: {
    visibleColumns(newValue) {
      const updateFields = [].concat([...this.fields]);
      updateFields.forEach(field => {
        field.visible = newValue.includes(field.name);
      });
      this.$set(this.fields, updateFields);
    },
    tableFilterValues: {
      deep: true,
      handler() {
        return;
      }
    }
  },
  methods: {
    validateOne() {
      return { result: true, errorMsg: "" };
    },
    validateTwo() {
      return { result: false, errorMsg: "There was an error" };
    },
    handleAddButtonClick() {
      this.$emit("addButton");
    },
    handleExportButtonClick() {
      this.$emit("exportButton");
    },
    handleUpdateButtonClick() {
      this.$emit("updateButton");
    },
    handleFilterValueChange(event) {
      this.tableFilterValues[event.name] = event.value;
    },
    handleRowAction(action) {
      this.$emit("rowAction", action);
    },
    handleRefresh() {
      this.gridPageRefresh += 1;
    },
    handleQuery(query) {
      this.$emit('query', query)
    }
  },
  mounted() {
    this.fields.forEach(field => {
      if (field["visible"] !== false) {
        this.visibleColumns.push(field.name);
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
